import { useContext } from 'react';

import { InviteMemberContext } from '../context/InviteMemberContext.js';

/** Wizard state + actions of the Invite members builder. Must be used inside `InviteMemberProvider`. */
export const useInviteMember = () => {
  const ctx = useContext(InviteMemberContext);
  if (!ctx) throw new Error('useInviteMember must be used inside an InviteMemberProvider');
  return ctx;
};
